import { render, staticRenderFns } from "./PUSdetail.vue?vue&type=template&id=2cde6f0b&"
import script from "./PUSdetail.vue?vue&type=script&lang=js&"
export * from "./PUSdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports